import { ISkill } from "@/api/skills";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, Copy } from "lucide-react";
import { useState } from "react";
import { DuplicateSkillDialog } from "./dialogs/DuplicateSkillDialog";

interface SkillsTableToolbarActionsProps {
    selectedSkill: ISkill | null;
}

export function SkillsTableToolbarActions({
    selectedSkill,
}: SkillsTableToolbarActionsProps) {
    const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);

    const handleDuplicate = () => {
        if (!selectedSkill) return;
        setDuplicateDialogOpen(true);
    };

    return (
        <>
            <DropdownMenu>
                <DropdownMenuTrigger
                    render={
                        <Button variant="outline" aria-label="Actions">
                            Actions
                            <ChevronDown className="size-4" />
                        </Button>
                    }
                />
                <DropdownMenuContent align="end">
                    <DropdownMenuItem
                        disabled={!selectedSkill}
                        onClick={handleDuplicate}
                    >
                        <Copy />
                        Duplicate
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
            {selectedSkill && (
                <DuplicateSkillDialog
                    key={selectedSkill.id}
                    open={duplicateDialogOpen}
                    onClose={() => setDuplicateDialogOpen(false)}
                    sourceSkill={selectedSkill}
                />
            )}
        </>
    );
}
